// Строка матча — что рисовать (чистая функция): подпись состояния над рядом команд (слово сервера
// status_long_localized; у идущего тайма перед ним — минута), пилюля по центру: у несыгранного без счёта — время начала
// по поясу запроса (kickoff_local_time), иначе счёт; живой — красной заливкой. Минута — только у живого и только у
// идущего тайма (у перерыва и серии пенальти её нет); закончился — минута исчезает.
import type { DayMatch } from '../../api/matchDay';

/** Коды без бегущей минуты: перерыв, пауза перед доп. временем, серия пенальти. */
const NO_CLOCK = new Set(['HT', 'BT', 'P', 'INT', 'SUSP']);

export interface RowView {
  live: boolean;
  /** «56'», «45+2'»; null — минуты нет */
  minute: string | null;
  caption: string;
  pill: { kind: 'time'; text: string } | { kind: 'score'; home: string; away: string };
  /** приглушить проигравшего */
  dim: 'home' | 'away' | null;
  penalty: { home: string; away: string } | null;
}

export function minuteLabel(row: DayMatch): string | null {
  if (row.is_live !== true || row.minute == null || NO_CLOCK.has(row.status)) return null;
  return row.minute_extra ? `${row.minute}+${row.minute_extra}'` : `${row.minute}'`;
}

export function rowView(row: DayMatch, tbd: string): RowView {
  const live = row.is_live === true;
  const s = row.score;
  const hasScore = s != null && s.home != null && s.away != null;
  const pill: RowView['pill'] = hasScore
    ? { kind: 'score', home: String(s!.home), away: String(s!.away) }
    : { kind: 'time', text: row.kickoff_time_known === false ? tbd : (row.kickoff_local_time ?? tbd) };
  const w = s?.winner_side;
  const pen = s?.penalty;
  return {
    live,
    minute: minuteLabel(row),
    caption: row.status_long_localized || row.status_long || row.status || '',
    pill,
    dim: w === 'home' ? 'away' : w === 'away' ? 'home' : null,
    penalty: pen && pen.home != null && pen.away != null ? { home: String(pen.home), away: String(pen.away) } : null,
  };
}
